class FeaturedProducts extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    this.connectCollectionToggles();
  }

  connectCollectionToggles() {
    const carousel = this.querySelector('carousel-slider');
    if (!carousel) return;
    const buttons = this.querySelectorAll('.js-block-toggle');
    const slides = this.querySelectorAll('.slider__item');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const blockId = button.dataset.blockId;

        // Update active button state
        buttons.forEach((btn) => {
          if (btn === button) {
            btn.dataset.active = 'true';
          } else {
            btn.dataset.active = 'false';
          }
        });

        slides.forEach((slide) => {
          if (slide.dataset.blockId === blockId) {
            slide.style.display = 'block';
          } else {
            slide.style.display = 'none';
          }
        });

        carousel.dispatchEvent(new CustomEvent('slider:content-changed', {
          bubbles: true
        }));
      });
    });
  }
}

customElements.define('featured-products', FeaturedProducts);